import type { Institution } from '@/models/catalog/course';

export const formatExternalInstitution = (courseData: {
  institution_id?: number;
  institution_name?: string;
  external_institution_logo_url?: string | null;
  external_institution_background_color?: string | null;
}): Institution => {
  return {
    id: courseData.institution_id || 0,
    name: courseData.institution_name || '',
    logo_url: courseData.external_institution_logo_url || '',
    logo_background_color:
      courseData.external_institution_background_color || '#000000',
    about: '',
  };
};
